<template>
  <div :class="state">
    <el-row class="about main-row">
      <el-col :span="24">
        <img src="http://leeno.com.cn:81/image/hezuo.jpg" style="width: 100%;box-shadow: 0 6px 17px 0px rgb(0 0 0 / 25%)"/>
        <div class="wrapper">
          <div class="title">
            <span>联系方式</span>
            <span class="line-separator"></span>
          </div>
        </div>
      </el-col>
    </el-row>
    <el-row class="contact main-row ">
      <div class="wrapper">
        <el-col :span="24">
          <div>
            <ul>
              <li class="company-name">上海力普科技服务公司</li>
              <li>邮政编号：201801</li>
              <li>联系电话：86-21-62054818</li>
              <li>电子邮箱：lip@leeno.com.cn</li>
              <li>公司地址：上海市嘉定区马陆镇丰饶路818号</li>
            </ul>
          </div>
        </el-col>
      </div>
    </el-row>
    <el-row class="about main-row">
      <el-col :span="24">
        <div class="wrapper">
          <div class="title">
            <span>企业地图</span>
            <span class="line-separator"></span>
          </div>
        </div>
      </el-col>
    </el-row>
    <el-row class="contact main-row ">
      <div class="wrapper">
        <div :span="24" style="margin: 0rem 0rem">
          <div style="text-align: center;box-shadow: 0 0px 18px 0px rgb(0 0 0 / 25%);" id="container" v-bind:style="mapStyle"></div>
        </div>
      </div>
    </el-row>
  </div>
</template>

<script>
import Share from '@/components/Share.vue'
import { useRouter } from "vue-router/dist/vue-router";
import { computed } from "vue";
import { useStore } from "vuex";

export default {
  name: 'Contact',
  components: {
    Share
  },
  setup() {
    const state = computed(() => useStore().state.client);
    return {
      state
    }
  },
  data() {
    return {
      mapStyle: {
        height: 6 + 'rem',
      },
    }
  },
  mounted() {
    var map = new T.Map('container')
    var point = new T.LngLat(
        121.29432849750158,
        31.35716235055457
    )
    map.centerAndZoom(point, 16)


    var marker = new T.Marker(point)
    map.addOverLay(marker)
  }
}
</script>

<style lang="scss" scoped>
.box {
}

h3 {
  font-weight: normal;
  font-size: .22rem;
  color: #505050;
}

ul, p {
  font-size: .16rem;
  margin-bottom: .4rem;

  li {
    line-height: .46rem;
    font-size: .16rem;
    color: #505050;
  }
}

.company-name {
  color: #505050;
  font-size: .3rem;
  margin-bottom: .12rem;

}

</style>
